import { render, staticRenderFns } from "./ReportCardKpi.vue?vue&type=template&id=2a4ea5d7&scoped=true"
import script from "./ReportCardKpi.vue?vue&type=script&lang=ts"
export * from "./ReportCardKpi.vue?vue&type=script&lang=ts"
import style0 from "./ReportCardKpi.vue?vue&type=style&index=0&id=2a4ea5d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ea5d7",
  null
  
)

export default component.exports